module.exports = __webpack_public_path__ + "img/time-sheet.e0402fb3.svg";